import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

// The dialog closes on submit, so a lost message reaches no one but us: the report carries its text.
export const sendFeedback = async (message: string) => {
  const functions = getFunctions();
  const send = httpsCallable(functions, 'users-sendFeedback');

  try {
    await send({ message });
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'send-feedback' },
      extra: { feedback: message },
    });
    throw error;
  }
};
